import * as react_components from "../reactcomponent"
import { Innosoft_InnoBI_Controllers_UserAdminController as UseradminController } from "../generated_api/generated_api"
import { UiBuildertoolBar } from "../components/ui_builder_toolbar"
import { BusyIndicatorDialog } from "../components/busy_indicator_dialog"
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Button } from "../../core/components/button";
import { DropDownList } from "../editor_common_components";
import { CheckBox } from "../../core/components/checkBox";
import { Menu, EntryType } from "../../core/components/menu";
import { Sheet } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { Helper } from "../../core/util/helper";
import { DialogHelper } from "../../core/util/dialogHelper";
import React from "react";

export class UserAdmin extends React.Component<any, any>{
    private userAdminController: UseradminController;
    private _sheet: Sheet = null;

    constructor(props: any) {
        super(props);
        this.state = {
            changedStatistics: {},
            showInternal: false,
            checkBoxKey: kendo.guid(),
        };
        this.userAdminController = new UseradminController();
        this._sheet = General.Sheet.Manager.getTopMostSheet();
        this._sheet.setUpUnloadHelper();
    }

    componentDidMount() {
        this.userAdminController.GetAllUSersAndStatisticsCurrentUser(this.state.showInternal, (userAdminViewModel) => {
            const vm = userAdminViewModel.Data;
            this.setState({ users: vm.Users, statistics: vm.StatisticsOfCurrentUser, selectedUser: vm.UserName });
        });
    }

    handleSave = () => {
        this.setState({ ajaxRequest: true, displayMessage: "Saving" });

        this.userAdminController.Save(this.state.selectedUser, this.state.changedStatistics, (result) => {
            NotificationHelper.showSuccessMessage("Saved successfully");
            this._sheet.getUnloadHelper().markEntitySaved();
            this.setState({ statistics: result.Data, changedStatistics: {}, ajaxRequest: false });
        });
    }

    handleCheckAll = () => {
        this.setPermissionForAll(1);
    }

    handleUncheckAll = () => {
        this.setPermissionForAll(0);
    }

    setPermissionForAll = (permission) => {
        for (let g of this.state.statistics) {
            for (let s of g.Statistics) {
                this.setPermission(s, permission);
            }
        }
    }

    handleSelectedUserChanged = async (value) => {
        const isSaved = this._sheet.getUnloadHelper() && this._sheet.getUnloadHelper().isEntitySaved();
        if (!isSaved) {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.TransEditor.DialogImportWarning2"));
            if (!isOk) {
                this.setState({ checkBoxKey: kendo.guid() });
                return;
            }

        }
        this.setState({ selectedUser: value, ajaxRequest: true, displayMessage: "Loading user data" });

        this.userAdminController.GetAllStatisticsWithRights(value, this.state.showInternal, (result) => {
            this.setState({ statistics: result.Data, changedStatistics: {}, ajaxRequest: false });
            this._sheet.getUnloadHelper().markEntitySaved();
        });

    }

    handleResetSettings = () => {
        this.setState({ isSaving: true, displayMessage: "Resetting" });
        this.userAdminController.ResetSettings(this.state.selectedUser, (result) => {
            this.setState({ statistics: result.Data, changedStatistics: {}, isSaving: false });
            this._sheet.getUnloadHelper().markEntitySaved();
        });
    }

    handleShowInternalChanged = async () => {
        const isSaved = this._sheet.getUnloadHelper() && this._sheet.getUnloadHelper().isEntitySaved();
        if (!isSaved) {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.TransEditor.DialogImportWarning2"));
            if (!isOk) {
                this.setState({checkBoxKey: kendo.guid() });
                return;
            }
                
        }
        this.setState({ajaxRequest: true, displayMessage: "Loading user data" });

        this.userAdminController.GetAllStatisticsWithRights(this.state.selectedUser, !this.state.showInternal, (result) => {
            this.setState({ showInternal: !this.state.showInternal, statistics: result.Data, changedStatistics: {}, ajaxRequest: false });
            this._sheet.getUnloadHelper().markEntitySaved();
        });
    }

    handleSelectAllIngroup = (group) => {
        for (let s of group) {
            this.setPermission(s, 1);
        }
        this._sheet.getUnloadHelper().markEntityChanged();
    }

    handleUncheckAllIngroup = (group) => {
        for (let s of group) {
            this.setPermission(s, 0);
        }
        this._sheet.getUnloadHelper().markEntityChanged();
    }

    handleRightChange = (statistic, e) => {
        var permission = (e.target.checked) ? 1 : 0;
        this.setPermission(statistic, permission);
        this._sheet.getUnloadHelper().markEntityChanged();
    }

    setPermission = (statistic, permission) => {

        statistic.changed = true;
        let changed = this.state.changedStatistics;
        if (!changed[statistic.Id]) {
            changed[statistic.Id] = { oldValue: statistic.UserRecht };
        }

        statistic.UserRecht = permission;

        changed[statistic.Id].newValue = statistic.UserRecht;
        if (changed[statistic.Id].newValue == changed[statistic.Id].oldValue) {
            delete changed[statistic.Id];
        }
        this.setState({ changedStatistics: changed });
    }

    renderStatistics = (statistic) => {
        let changed = null;

        if (this.state.changedStatistics[statistic.Id]) {
            changed = <div style={{ display: "inline-block" }}>*</div>;
        }

        let rollenRecht = statistic.RollenRecht == 1 && statistic.UserRecht == null ? <div style={{ display: "inline-block", backgroundColor: "lightGreen" }}> (Role: {statistic.Rolle}) </div> : null;
        return (
            <li key={statistic.Id}>
                <div  >
                    <input type="checkbox" onChange={this.handleRightChange.bind(this, statistic)} checked={statistic.UserRecht === 1 || (statistic.RollenRecht == 1 && statistic.UserRecht == null)} /> <a target="_blank" href={`uiBuilderDetail?id=${statistic.Id}`}> {statistic.Name}</a> {changed}
                    {rollenRecht}
                </div>
            </li >
        )
    }


    renderCategories(categorie) {
        let statistics = categorie.Statistics.sort((a, b) => a.Name.localeCompare(b.Name)).map(this.renderStatistics);
        return (
            <li key={categorie.Name}>
                <div>
                    <b>{categorie.Name}</b>
                    <button className="innoOptionsButton" style={{ marginLeft: "5px", backgroundImage: "none" }} onClick={this.handleSelectAllIngroup.bind(this, categorie.Statistics)} >+</button>
                    <button className="innoOptionsButton" style={{ marginLeft: "5px", backgroundImage: "none" }} onClick={this.handleUncheckAllIngroup.bind(this, categorie.Statistics)} >-</button>                </div>
                <ul style={{ listStyleType: "none", marginLeft: "15px" }}>
                    {statistics}
                </ul>
            </li>)
    }
    renderStatisticsTree = () => {
        let categories = this.state.statistics ? this.state.statistics.map(this.renderCategories.bind(this)) : null;
        return (this.state.statistics ?
            <ul style={{ listStyleType: "none" }}>
                <b>{Helper.getTranslation("WebSMS.Statistics.AllStatistics")} </b>
                <button className="innoOptionsButton" style={{ marginLeft: "5px", backgroundImage: "none" }} onClick={this.handleCheckAll.bind(this)} >+</button>
                <button className="innoOptionsButton" style={{ marginLeft: "5px", backgroundImage: "none" }} onClick={this.handleUncheckAll.bind(this)} >-</button>
                <li style={{ marginTop: "5px", marginLeft: "15px" }}>
                    <ul style={{ listStyleType: "none" }}>
                        {categories}
                    </ul>
                </li>
            </ul> : null
        )
    }



    render() {

        var dialog = this.state.ajaxRequest === true ? <BusyIndicatorDialog title={this.state.displayMessage} /> : null;

        var statisticsTreee = this.renderStatisticsTree();
        return <FullHeightContainer classes="flex-container--column">
            <Menu entries={[
                { type: EntryType.Save, onClick: this.handleSave },
                { text: Helper.getTranslation("WebSMS.Statistics.ResetSettings"), onClick: this.handleResetSettings, icon: "recycle" }
            ]}
                onSelect={() => { }}
                enableMenuItem={() => true}
                handleEval={() => { }} />

            <div style={{ height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
                
                <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "anchor-center", paddingTop: "5px" }}>
                    
                    <div style={{ width: "50%" , paddingRight: "20px"} }>
                        <DropDownList label={Helper.getTranslation("WebCRM.Administration.Benutzer") + "/" + Helper.getTranslation("WebSMS.Ticket.Allocations.Role") + " - " + Helper.getTranslation("BrowserTitle.Resource.Available") }
                            name="type"
                            filter="contains"
                            value={this.state.selectedUser}
                            data={this.state.users}
                            valueField="DisplayName"
                            keyField="Login"
                            onChange={this.handleSelectedUserChanged.bind(this)} />
                    </div>
                    <div >
                        <CheckBox field={{ type: "n/a", model: "onlyParents", name: Helper.getTranslation("WebSMS.Statistics.ShowInternal"), labelAndControlCombined: true }}
                            value={this.state.showInternal}
                            onChange={this.handleShowInternalChanged}
                            disabled={false}
                            key={this.state.checkBoxKey}
                        />
                    </div>

                </div>
                
                <div style={{ height: "100%", display: "flex", flexDirection: "row", overflow: "auto", marginTop: "5px" }}>
                    
                    
                    {statisticsTreee}
                </div>
            </div>
        </FullHeightContainer>

    }
}

